export interface HiddenBackgroundProps {
  'aria-hidden': boolean;
  inert: boolean;
}

/**
 * Props to hide background content while an overlay (modal, drawer, overlay of
 * another portlet, ...) is open.
 *
 * Spread the result onto the background element, e.g.
 * `<div {...hiddenBackgroundProps(isOverlayOpen)}>`. This always sets
 * `aria-hidden` (hides the content from screen readers) and `inert` (removes it
 * from the tab order and disables interaction) together, so that both stay in
 * sync.
 *
 * @param hidden whether the background content should be hidden
 */
export function hiddenBackgroundProps(hidden: boolean): HiddenBackgroundProps {
  return { 'aria-hidden': hidden, inert: hidden };
}
